import { render } from "./TheSettingsList.vue?vue&type=template&id=3db0ab0a&scoped=true"
import script from "./TheSettingsList.vue?vue&type=script&lang=js"
export * from "./TheSettingsList.vue?vue&type=script&lang=js"

import "./TheSettingsList.vue?vue&type=style&index=0&id=3db0ab0a&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db0ab0a"]])

export default __exports__